module.exports = __webpack_public_path__ + "static/media/logo_nav.7e4125c4.png";